$(document).foundation();

jQuery(document).ready(function($) {

	$('body').on('click', '.js-load-more', function(event) {
		event.preventDefault();
		/* Act on the event */
		var $this = $(this), $target = $('#'+$this.data('ajaxtarget'));

		$.ajax({
			url: $this.attr('href'),
			type: 'GET'
		})
		.done(function(json) {
			$target.append(json.content);

			if(json.nextUrl) {
				$this.attr('href' ,json.nextUrl);
			} else {
				$this.remove();
			}
		});

	});
});